export default "__VITE_ASSET__Da5Rmu3y__"